<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <n-divide class="table-tools">
      <div></div>
      <n-link v-if="edit.records" :to="createRecordLink()"><n-button>Создать запись</n-button></n-link>
    </n-divide>

    <n-table :columns="columns" :data="data">
      <template #headerRow>
        <tr class="header">
          <td>№ п.п</td>
          <td>Обозначение сварного соединения по исполнительному чертежу, тип сварного соединения</td>
          <td>Ф.И.О.. сварщика, личное клеймо</td>
          <td>Марка стали (композиция марок стали), НТД, № сертификатов</td>
          <td>Наружный диаметр элемента трубопровода и толщина стенки Dn * S, мм</td>
          <td>Дата сварки, температурные условия в рабочей зоне, С</td>
          <td>Способ сварки</td>
          <td>Сварные материалы (марка электрода, сварочной проводки, защитный газ, флюс), НТД , № сертификатов</td>
          <td>Режим предварительного и сопутствующего подогрева</td>
          <td>Отметка о контроле корня шва</td>
          <td>Стилоскопирование металла шва, № заключения, дата</td>
          <td>Ф.И.О. оператора-термиста, личное клеймо</td>
          <td>№ диаграммы по журналутермообработки сварных соединений</td>
          <td>Замер твердости металла шва, № заключения, дата</td>
          <td>Отметка о годности сварного соединения по внешнему осмотру и измерениям</td>
          <td>Способ и результат неразрушающего контроля сварного соединения, № заключения, дата</td>
          <td>Результаты замера феритной фазы в металле, № заключения, дата</td>
          <td></td>
        </tr>
        <tr class="header">
          <td>1</td>
          <td>2</td>
          <td>3</td>
          <td>4</td>
          <td>5</td>
          <td>6</td>
          <td>7</td>
          <td>8</td>
          <td>9</td>
          <td>10</td>
          <td>11</td>
          <td>12</td>
          <td>13</td>
          <td>14</td>
          <td>15</td>
          <td>16</td>
          <td>17</td>
          <td></td>
        </tr>
        <tr class="header">
          <td colspan="17">ПРИМЕЧАНИЕ Графы 9 - 14, 17 заполняются при наличии соответсвующих указаний в рабочей документации</td>
          <td></td>
        </tr>
      </template>
      <template #date="{item}">
        {{ $app.date.format(item.date) }}
      </template>
      <template #tools="{item}">
        <n-link :to="showRecordLink(item.id)"><n-button icon="eye" /></n-link>
      </template>
    </n-table>

    <page-record-create v-if="newRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(createRecordLink(false))" />
    <modal-record v-if="showRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(showRecordLink(false))" />
  </div>
</template>

<script>
import PageRecordCreate from './Create'
import ModalRecord from './record/Index'
import utils from 'utils'

export default {
  name: 'MainChapter4',
  components: { ModalRecord, PageRecordCreate, },
  props: [ 'project', 'journal', ],
  data: () => ({
    utils,
    data: [
    ],
  }),
  computed: {
    newRecord() {
      return this.$route.query['new'] !== undefined
    },
    showRecord() {
      return this.$route.query['show'] !== undefined
    },
    edit() {
      return {
        records: $app.auth.can('journals_'+this.journal.name+'_records', this.project.id),
      }
    },
    columns() {
      return [
        { name: 'number', title: '', },
        { name: 'titleType', title: '', },
        { name: 'welder', title: '', },
        { name: 'steelMark', title: '', },
        { name: 'outDiameter', title: '', },
        { name: 'weldingDate', title: '', },
        { name: 'weldingType', title: '', },
        { name: 'weldingMaterial', title: '', },
        { name: 'heatingMode', title: '', },
        { name: 'controleMark', title: '', },
        { name: 'steeloscopy', title: '', },
        { name: 'operator', title: '', },
        { name: 'diagramNumber', title: '', },
        { name: 'steelHard', title: '', },
        { name: 'okMark', title: '', },
        { name: 'resultControl', title: '', },
        { name: 'result', title: '', },
        { name: 'tools', title: '', },
      ]
    },
  },
  watch: {
    project() {
      this.load()
    },
  },
  mounted() {
    this.load() 
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, this.journal.name)
        .query({
          'with[records][with][participation]': null,
          'with[signs][with][author]': null,
          projectId: this.project.id,
        })
        .then((response) => {
          this.data = response.data.content
        }).finally(() => {
          this.$var('load', false)
        })
    },
    getUser(item, name) {
      if (!item[name]) {
        return ''
      }
      return item[name]?.participation?.position + ', ' + item[name]?.fullName
    },
    createRecordLink(open = true) {
      return { query: { ...this.$route.query, 'new': open ? null : undefined, }, }
    },
    showRecordLink(open) {
      return { query: { ...this.$route.query, 'show': open || undefined, }, }
    },
    getSign(item, name) {
      return $n.find(item.signs, [ 'name', name, ])
    },
  },
}
</script>

<style lang="scss" scoped>
.main-chapter1 {

}
</style>
